import {
  GET_DMX_UNIVERSES_BY_CONTROLLER,
  GET_DMX_UNIVERSES_BY_CONTROLLER_SUCCESS,
  GET_DMX_UNIVERSES_BY_CONTROLLER_ERROR,
} from './actionTypes';

export const getDmxUniversesByController = (user, controllerId) => {
  return {
    type: GET_DMX_UNIVERSES_BY_CONTROLLER,
    payload: { user, controllerId },
  };
};

export const getDmxUniversesByControllerSuccess = (universes) => {
  return {
    type: GET_DMX_UNIVERSES_BY_CONTROLLER_SUCCESS,
    payload: { universes },
  };
};

export const getDmxUniversesByControllerError = (error) => {
  return {
    type: GET_DMX_UNIVERSES_BY_CONTROLLER_ERROR,
    payload: error,
  };
};
